interface FAQ {
  question: string;
  answer: string;
}

export const capsulaFAQs: Record<string, FAQ[]> = {
  "creacion-videos": [
    {
      question: "¿Necesito saber editar video?",
      answer: "No. Estas herramientas hacen todo por ti. Solo escribes lo que quieres mostrar o hablas tu guion, y la IA genera el video completo. No necesitas programas de edición ni experiencia previa."
    },
    {
      question: "¿Cuánto tarda en generarse un video?",
      answer: "Entre 5 y 15 minutos dependiendo de la duración. Un video de 30 segundos suele estar listo en unos 5-7 minutos. Mientras tanto puedes seguir trabajando en otras cosas."
    },
    {
      question: "¿Puedo usar los videos para mi negocio sin problemas legales?",
      answer: "Sí, los videos generados son tuyos y puedes usarlos comercialmente. Cada herramienta tiene sus términos, pero en general tienes derechos completos sobre lo que creas."
    },
    {
      question: "¿Se nota que es IA o parece profesional?",
      answer: "Los resultados son sorprendentemente profesionales. La calidad ha mejorado tanto que muchos videos de IA son indistinguibles de producciones reales. Puedes verlo por ti mismo en los ejemplos de cada guía."
    },
    {
      question: "¿Cuánto cuesta usar estas herramientas?",
      answer: "Muchas tienen planes gratuitos para empezar. Los planes de pago suelen estar entre 10-30€/mes y te permiten crear videos ilimitados. Es mucho más barato que contratar una productora o comprar equipo."
    }
  ],

  "automatizacion-emails": [
    {
      question: "¿La IA responderá correctamente a mis clientes?",
      answer: "Sí, pero tú decides el nivel de automatización. Puedes configurarla para que responda automáticamente solo a preguntas frecuentes, o que prepare borradores que tú revisas antes de enviar. Tienes el control total."
    },
    {
      question: "¿Funciona con mi correo actual?",
      answer: "Sí. Estas herramientas se conectan con Gmail, Outlook y prácticamente cualquier servicio de email. No tienes que cambiar tu correo ni migrar nada."
    },
    {
      question: "¿Cuántas horas realmente puedo ahorrar?",
      answer: "Nuestros clientes reportan ahorrar entre 10-15 horas semanales. Si respondes muchos emails repetitivos o procesas facturas manualmente, el ahorro puede ser aún mayor."
    },
    {
      question: "¿Es complicado de configurar?",
      answer: "La configuración básica toma unos 30 minutos. Sigues una guía paso a paso y la herramienta aprende de tus correos anteriores. Cuanto más la uses, mejor funciona."
    },
    {
      question: "¿Qué pasa si la IA comete un error?",
      answer: "Puedes configurar alertas y revisión previa antes de que se envíe cualquier respuesta importante. También puedes empezar solo con tareas de bajo riesgo (clasificar correos, extraer datos) hasta que le cojas confianza."
    }
  ],

  "creacion-presentaciones": [
    {
      question: "¿Solo funciona con PowerPoint?",
      answer: "No, también funciona con Google Slides y otras plataformas. La mayoría de herramientas te permiten exportar en diferentes formatos."
    },
    {
      question: "¿Puedo personalizar el diseño después?",
      answer: "Totalmente. La IA genera una base profesional y tú puedes editar colores, fuentes, imágenes y cualquier elemento como lo harías normalmente. Es solo un punto de partida mucho más rápido."
    },
    {
      question: "¿Sirve para presentaciones técnicas o solo comerciales?",
      answer: "Funciona para cualquier tipo: ventas, informes, formación, pitches de inversión, análisis de datos... Solo tienes que ser claro en lo que necesitas."
    },
    {
      question: "¿Genera las imágenes también?",
      answer: "Algunas herramientas sí incluyen imágenes de stock o generadas por IA. Otras te sugieren dónde colocar imágenes y tú las añades. Depende de la herramienta que uses."
    },
    {
      question: "¿Cuánto tarda en crear una presentación?",
      answer: "Una presentación completa de 10-15 diapositivas puede estar lista en 5-10 minutos. Luego le dedicas otros 10-15 minutos a personalizarla. En total, lo que antes te llevaba 2 horas ahora son 20 minutos."
    }
  ],

  "agentes-voz": [
    {
      question: "¿Suena robotizado o natural?",
      answer: "Las voces actuales de IA son muy naturales. Muchos clientes no notan la diferencia con una persona real, especialmente en conversaciones simples como dar información o tomar pedidos."
    },
    {
      question: "¿Puede manejar todas mis llamadas o solo algunas?",
      answer: "Tú decides. Puedes configurarlo para que atienda fuera de horario, que filtre llamadas antes de pasártelas, o que maneje solo consultas frecuentes. Es flexible según tus necesidades."
    },
    {
      question: "¿Funciona en español correctamente?",
      answer: "Sí, las herramientas modernas funcionan perfectamente en español con diferentes acentos. Pueden entender y responder en el idioma que necesites."
    },
    {
      question: "¿Es muy caro implementarlo?",
      answer: "No. Algunos servicios tienen planes desde 30-50€/mes. Comparado con contratar personal adicional, es mucho más económico y está disponible 24/7 sin días libres ni vacaciones."
    },
    {
      question: "¿Qué pasa si el cliente hace una pregunta complicada?",
      answer: "El agente puede transferir la llamada a una persona real o tomar los datos para que tú devuelvas la llamada. No tiene que resolver todo, solo lo que tú le enseñes."
    }
  ],


  "analisis-documentos": [
    {
      question: "¿Qué tipo de documentos puedo analizar?",
      answer: "PDFs, Word, Excel, presentaciones, imágenes de texto... Prácticamente cualquier documento que tengas. La IA extrae información de todos ellos."
    },
    {
      question: "¿Mis documentos quedan privados?",
      answer: "Depende de la herramienta que uses. Algunas procesan todo localmente en tu ordenador, otras usan servidores seguros. Las guías especifican qué opciones son mejores para datos sensibles."
    },
    {
      question: "¿Cuántos documentos puedo subir?",
      answer: "Varía según la herramienta. Las versiones gratuitas suelen permitir varios documentos, las de pago pueden manejar cientos o miles al mismo tiempo."
    },
    {
      question: "¿Es mejor que buscar con Ctrl+F?",
      answer: "Mucho mejor. No solo encuentra palabras exactas, sino que entiende el contexto. Puedes hacer preguntas naturales como '¿cuál fue el presupuesto del año pasado?' y te da la respuesta aunque no esté escrita exactamente así."
    },
    {
      question: "¿Funciona con documentos antiguos o escaneados?",
      answer: "Sí, con documentos escaneados o imágenes de texto también funciona. La tecnología OCR extrae el texto automáticamente antes de analizarlo."
    }
  ],

  "redes-sociales": [
    {
      question: "¿Necesito saber diseño o Photoshop?",
      answer: "Para nada. Estas herramientas funcionan escribiendo lo que quieres ver. 'Un logo moderno para cafetería' o 'meme gracioso sobre el lunes'. La IA se encarga del diseño."
    },
    {
      question: "¿Puedo usarlo para mi logo y contenido de marca?",
      answer: "Sí, puedes generar propuestas de logos, imágenes para redes, flyers, banners... Todo lo visual que necesites. Algunos negocios usan IA para su branding completo."
    },
    {
      question: "¿Las imágenes son únicas o las usa más gente?",
      answer: "Son únicas. Cada imagen que generas es nueva y diferente. No hay riesgo de que tu competencia use la misma imagen."
    },
    {
      question: "¿Qué calidad tienen las imágenes y contenidos?",
      answer: "Alta resolución, listas para impresión o uso digital. La calidad ha mejorado enormemente y ya no se nota que son generadas por IA en la mayoría de casos."
    },
    {
      question: "¿Cuánto cuesta?",
      answer: "Muchas herramientas tienen planes gratuitos con límites al mes. Los planes de pago suelen estar entre 10-25€/mes con generaciones ilimitadas o muy altas."
    }
  ],

  "herramientas-desarrollo": [
    {
      question: "¿Es solo para programadores?",
      answer: "Esta cápsula está más orientada a equipos con desarrolladores, sí. Si tienes un informático en tu equipo o trabajas con freelancers técnicos, estas herramientas multiplican su productividad."
    },
    {
      question: "¿Qué tipo de desarrollos acelera?",
      answer: "Desde crear prototipos rápidos hasta automatizaciones complejas, integraciones con APIs, análisis de datos... Cualquier cosa que requiera código se puede acelerar significativamente."
    },
    {
      question: "¿Reemplaza a los desarrolladores?",
      answer: "No, los potencia. Un desarrollador con estas herramientas puede hacer el trabajo de 2-3 desarrolladores sin ellas. Es como darle mejores herramientas a un carpintero."
    },
    {
      question: "¿Es difícil de aprender para un desarrollador?",
      answer: "No. La mayoría de estas herramientas tienen interfaces intuitivas. Un desarrollador puede estar productivo con ellas en cuestión de horas, no semanas."
    },
    {
      question: "¿Vale la pena la inversión?",
      answer: "Si tienes proyectos de desarrollo, absolutamente. El ahorro en tiempo de desarrollo se traduce en proyectos más rápidos y costes menores. Se amortiza rápidamente."
    }
  ]
};
